/* eslint-disable max-len */
import config from "../config/config.ts";
import { A, B, C, R1, R2, R3, R4, R5, R6, R7, R8, R9, R10, D1, D2, D3, D4, D5, D6, D7, D8, D9, D10, C1, C2, C3, C4, C5, C6, C7, C8, C9, C10, C11, C12 } from "./constants.ts";

const { BACK_API_KEY, BACK_URL } = config;

export const optionsNumberToLetterDict: { [key: number]: string } = {
  0: A,
  1: B,
  2: C,
};

export const parseAnswers = (answers: { [key: string]: number }) =>
  Object.keys(answers).reduce(
    (acc, current) => ({
      ...acc,
      [current]: optionsNumberToLetterDict[answers[current]],
    }),
    {} as { [key: string]: string }
  );

export const getDecryptedVideos = (
  encryptedVideos: string
): Promise<string> => {
  //TODO: usar url del .env
  return fetch(`${BACK_URL}/decrypt/${encryptedVideos}`, {
    headers: { apikey: BACK_API_KEY },
  })
    .then((res) => {
      return res.text();
    })
    .then((text) => {
      return text.toString(); //TODO: no se si este toString es necesario
    });
};

export const getCloudSignedUrls = (
  publicIds: string
): Promise<{ signedUrls: string[] }> => {
  return fetch(`${BACK_URL}/assets`, {
    headers: { apikey: BACK_API_KEY, "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify({ publicIds }),
  }).then((res) => res.json());
};

export const textsByAxis: { [key: string]: { text: string; title: string } } = {
  [R1]: {
    title: "Resiliencia como motor",
    text: `Aun cuando una dificultad te golpea con fuerza, tendés a
encontrar nuevamente un punto desde el cual seguir adelante. Eso no significa que no
sufras ni que todo te resulte fácil. Significa que **el problema no suele tener la última
palabra sobre tu vida.**
El riesgo es olvidar este recurso justamente cuando aparece una nueva crisis y sentir que
esta vez no vas a poder. Tu propia historia puede recordarte algo diferente: ya
desarrollaste capacidad para reconstruirte y recuperar una dirección.
Para seguir fortaleciendo: **recordar tus recursos anteriores cuando una dificultad nueva
te haga dudar de ellos.**`,
  },
  [R2]: {
    title: "Regulación emocional estable",
    text: `Solés conservar cierto equilibrio aun cuando aparecen
presión, cambios inesperados o situaciones emocionalmente exigentes. Sentís lo que
ocurre, pero muchas veces conseguís que **la emoción no sea la única que decida por vos.**
Este recurso es especialmente valioso porque conservar el eje también ayuda a conservar
claridad. El riesgo aparece cuando el cansancio o una acumulación de problemas hacen
que des por perdida una capacidad que normalmente está disponible.
Regular tus emociones no significa sentir menos. Significa poder seguir pensando y
decidiendo aun cuando algo te afecta.
Para seguir fortaleciendo: **proteger los hábitos y condiciones que te ayudan a recuperar
equilibrio antes de tomar decisiones importantes.**`,
  },
  [R3]: {
    title: "Claridad de rumbo",
    text: `Tenés cierta capacidad para distinguir hacia dónde querés
dirigir tus esfuerzos y qué merece hoy mayor prioridad. Cuando ese eje está claro, no
necesitás resolver todo al mismo tiempo: podés organizar decisiones y energía alrededor
de una dirección.
El riesgo es confundir rumbo con rigidez. **Una dirección sirve mientras continúa
ayudándote a construir; si la realidad cambia, también puede necesitar ajustes.**

Tener rumbo no significa conocer exactamente el futuro. Significa contar con una
orientación suficientemente clara para que tus decisiones no dependan solamente de la
urgencia del momento.
Para seguir fortaleciendo: **sostener una dirección clara y revisarla cuando aparezcan
hechos que justifiquen corregirla.**`,
  },
  [R4]: {
    title: "Visión futura",
    text: `Tenés facilidad para imaginar posibilidades, anticipar
movimientos o percibir caminos antes de que estén completamente definidos. Esa
capacidad puede ayudarte a detectar oportunidades que otras personas todavía no ven.
**Su mayor valor aparece cuando la imaginación permanece conectada con la realidad.** Una
posibilidad prometedora no deja de necesitar hechos que la sostengan. Cuando esa
comprobación falta, existe el riesgo de confundir lo deseado con lo probable.
Tu visión puede ampliar el mapa, siempre que después contrastes lo que imaginás con lo
que realmente está ocurriendo.
Para seguir fortaleciendo: **usar tu capacidad de anticipación como hipótesis y
contrastarla con información concreta antes de decidir.**`,
  },
  [R5]: {
    title: "Relación pensamiento–acción",
    text: `Solés encontrar un equilibrio útil entre comprender una
situación y empezar a actuar sobre ella. No necesitás tener todas las respuestas antes de
moverte, pero tampoco parecés decidir solamente por impulso.
Esa combinación es importante porque muchas cuestiones no terminan de aclararse
mientras permanecen únicamente en el pensamiento. **Cuando actuás, la realidad empieza
a devolverte información que antes no estaba disponible.**
El desafío es conservar ese equilibrio cuando aumenta la incertidumbre: ni quedar
detenido analizando indefinidamente ni acelerar para escapar de la duda.
Para seguir fortaleciendo: **transformar el análisis en una acción concreta cuando seguir
pensando ya no aporta información relevante.**`,
  },
  [R6]: {
    title: "Foco en lo importante",
    text: `Tendés a distinguir aquello que realmente merece tu atención
y a mantener cierta continuidad sobre lo que considerás importante. Este recurso permite
que tus esfuerzos tengan más posibilidades de convertirse en resultados.

El principal riesgo aparece cuando demasiadas urgencias comienzan a competir por el
mismo lugar. En esos momentos, incluso una persona enfocada puede terminar ocupada
en muchas cosas sin avanzar suficientemente en ninguna.
**Recuperar foco no exige hacer más. Muchas veces exige decidir qué puede esperar para
proteger aquello que hoy tiene mayor impacto.**
Para seguir fortaleciendo: **jerarquizar con claridad tus prioridades y evitar que lo
urgente desplace sistemáticamente a lo importante.**`,
  },
  [R7]: {
    title: "La comunicación que funciona",
    text: `Muchas veces conseguís expresar lo que pensás o necesitás de
una manera que facilita la comprensión y evita conflictos innecesarios. Eso aumenta tu
capacidad para intervenir sobre situaciones que dependen también de otras personas.
Comunicar bien no consiste en lograr que los demás siempre estén de acuerdo con vos.
**Consiste en hacer suficientemente visible tu posición para que pueda ser comprendida,
discutida y tenida en cuenta.**
Este recurso adquiere todavía más valor en conversaciones difíciles, donde la forma
puede facilitar o destruir la posibilidad de construir una salida.
Para seguir fortaleciendo: **expresar con claridad lo importante sin perder de vista el
resultado que querés construir con esa conversación.**`,
  },
  [R8]: {
    title: "Lo que depende de vos",
    text: `Podrías tener una capacidad importante para **diferenciar aquello sobre lo que
podés intervenir de aquello que no está enteramente en tus manos.** Esa distinción evita
desperdiciar energía intentando controlar lo incontrolable.
También te permite recuperar una pregunta muy útil frente a los problemas: no solamente
“¿qué está pasando?”, sino “¿qué puedo hacer yo frente a esto?”.
El equilibrio consiste en no caer en ninguno de los extremos: ni sentirte impotente ante
todo ni hacerte responsable de aquello que corresponde a otros o depende de
circunstancias externas.
Para seguir fortaleciendo: **concentrar tu esfuerzo en los márgenes reales de intervención
sin cargar con responsabilidades que no te corresponden.**`,
  },
  [R9]: {
    title: "Involucrarte con los demás",
    text: `Cuando considerás que podés aportar, tendés a involucrarte
en lugar de permanecer como simple espectador. Proponer, colaborar o ayudar a resolver
situaciones amplía tu capacidad de producir cambios en los espacios que compartís.
El riesgo aparece si participar empieza a confundirse con tener que ocuparte de todo.
**Intervenir también puede significar generar las condiciones para que otras personas
asuman su parte.**
Tu disposición a involucrarte es un recurso especialmente valioso cuando está
acompañada por una lectura clara de cuál es realmente tu lugar.
Para seguir fortaleciendo: **intervenir donde tu aporte puede generar valor sin asumir
aquello que también corresponde construir a los demás.**`,
  },
  [R10]: {
    title: "Propósito",
    text: `Frente a decisiones importantes, necesitás encontrar un “para
qué” que vaya más allá de la conveniencia inmediata. Esa búsqueda puede ayudarte a
ordenar elecciones y sostener esfuerzos que de otra manera perderían sentido.
**El propósito se vuelve verdaderamente útil cuando deja de ser una idea abstracta y
empieza a orientar decisiones concretas**: a qué dedicás tiempo, qué postergás, qué aceptás
y qué decidís dejar atrás.
No necesitás descubrir una misión definitiva para toda tu vida. Necesitás comprobar que
aquello que construís guarda relación con la vida que querés vivir.
Para seguir fortaleciendo: **usar tu propósito como criterio concreto para elegir dónde
invertir tiempo, energía y compromiso.**`,
  },
  [D1]: {
    title: "Recuperarte de las dificultades",
    text: `Cuando aparece una dificultad importante, podría costarte
recuperar una posición desde la cual volver a actuar. El problema empieza entonces a
ocupar más espacio del que debería y puede terminar organizando buena parte de tu vida
alrededor suyo.
En esos momentos, quizás no necesites resolver todo para empezar a recuperarte. Muchas
veces alcanza con identificar un primer punto de apoyo: una decisión, una conversación o
una acción posible.

**La recuperación comienza cuando el problema deja de ser todo el escenario y vuelve a
convertirse en una parte de la realidad sobre la que podés empezar a intervenir.**
Para trabajar: **identificar un primer movimiento posible cuando una dificultad te haga
sentir que no hay por dónde empezar.**`,
  },
  [D2]: {
    title: "Abrirte a los demás",
    text: `Podrías dedicar bastante energía a protegerte antes de
comprobar si una persona o una situación representan realmente una amenaza. Esa
cautela puede haber sido útil en determinados momentos, pero también puede terminar
funcionando automáticamente.
Cuando esto ocurre, **la protección no solamente evita riesgos: también limita vínculos,
ayuda, intercambio y oportunidades.**
No se trata de confiar indiscriminadamente. Se trata de recuperar capacidad de distinguir,
para que experiencias anteriores no decidan de antemano cómo vas a relacionarte con
todas las personas nuevas.
Para trabajar: **diferenciar los riesgos que existen hoy de aquellos que estás anticipando
por experiencias anteriores.**`,
  },
  [D3]: {
    title: "Acercarte a los demás",
    text: `En determinadas situaciones, podrías sentirte más seguro
manteniendo cierta distancia de los demás. Esa posición reduce exposición, pero cuando
se vuelve habitual también reduce las posibilidades de recibir apoyo, intercambiar
perspectivas o construir vínculos significativos.
El punto no es transformarte en una persona más extrovertida. **Es revisar si la distancia
responde realmente a una elección actual o si terminó convirtiéndose en una forma
automática de protección.**
A veces un pequeño acercamiento produce información que desde afuera nunca aparece.
Para trabajar: **abrir gradualmente espacios de contacto donde puedas comprobar si
acercarte amplía, en lugar de reducir, tus posibilidades.**`,
  },
  [D4]: {
    title: "Contar con los demás",
    text: `Podrías estar enfrentando demasiadas cuestiones importantes
como si dependieran exclusivamente de vos. Cuando todo se procesa en soledad, los
problemas pueden parecer más grandes porque falta el contraste de otras miradas.

**Apoyarte en alguien no implica entregar la conducción de tu vida.** Una conversación
adecuada puede ayudarte a distinguir hechos, ordenar prioridades o descubrir alternativas
que hoy no estás viendo.
No necesitás una red enorme. Necesitás reconocer quiénes son las personas con las que
realmente podés pensar, compartir y construir.
Para trabajar: **identificar y fortalecer vínculos concretos en los que puedas apoyarte sin
perder autonomía.**`,
  },
  [D5]: {
    title: "Encontrar equilibrio emocional",
    text: `En algunos momentos, lo que sentís podría modificar
demasiado la manera en que interpretás lo que está ocurriendo. Entonces un problema
puede parecer muy distinto según el estado emocional desde el que lo estés mirando.
**La emoción contiene información, pero no siempre describe con precisión toda la
realidad.** El riesgo aparece cuando una sensación intensa empieza a funcionar como si
fuera una conclusión.
Generar una pequeña distancia antes de decidir puede cambiar significativamente tu
manera de responder.
Para trabajar: **distinguir entre lo que estás sintiendo y lo que efectivamente sabés antes
de tomar decisiones importantes.**`,
  },
  [D6]: {
    title: "Tomar decisiones",
    text: `Frente a algunas decisiones importantes, podrías seguir
analizando aun cuando el análisis ya no está aportando información verdaderamente
nueva. En ese punto, **pensar deja de ayudarte a decidir y empieza a postergar la decisión.**
El problema puede no ser que te falte capacidad para elegir, sino que estés esperando una
seguridad que ninguna decisión importante puede ofrecer de antemano.
Muchas veces una parte de la claridad aparece recién cuando actuamos y observamos
cómo responde la realidad.
Para trabajar: **reconocer cuándo seguir pensando ya no mejora la decisión y es
momento de dar un primer paso.**`,
  },
  [D7]: {
    title: "Recuperar el rumbo",
    text: `Hoy podría costarte encontrar una dirección suficientemente
clara para organizar tus esfuerzos. Cuando falta ese eje, no solamente cuesta decidir hacia

dónde ir: también todo empieza a parecer igualmente importante y la mente puede quedar
girando alrededor de las mismas preguntas.
Quizás no necesites descubrir ahora el rumbo perfecto. Podrías necesitar algo más
concreto: **elegir una dirección suficientemente valiosa como para empezar a caminar y
permitir que la experiencia te aporte nueva información.**
Para trabajar: **construir una dirección mínima y sostenerla el tiempo suficiente para
empezar a recuperar claridad.**`,
  },
  [D8]: {
    title: "Expresar lo necesario",
    text: `Cuando algo importante necesita ser dicho, podrías
postergarlo o callarlo para evitar tensión, conflicto o incomodidad. El costo es que la
situación sigue avanzando sin incorporar una información que quizás era necesaria para
poder cambiar.
**Los demás no pueden tener en cuenta aquello que nunca llega a expresarse.** Callar
también interviene sobre la realidad, porque permite que las cosas continúen como están.
No se trata de decir todo. Se trata de reconocer qué conversaciones ya no conviene seguir
evitando.
Para trabajar: **poner en palabras, de manera clara y respetuosa, aquello que necesitás
que los demás conozcan para poder construir una situación diferente.**`,
  },
  [D9]: {
    title: "Construir acuerdos",
    text: `Cuando una diferencia te afecta mucho, podrías concentrar
tanta energía en defender tu posición que el objetivo original de la conversación termine
quedando en segundo plano.
En ese momento aparece una pregunta decisiva: **¿querés demostrar quién tiene razón o
producir un resultado mejor?**
Reubicar la conversación alrededor de lo que realmente querés construir no exige
renunciar a tus ideas. Exige elegir una forma de defenderlas que mantenga abierta la
posibilidad de avanzar.
Para trabajar: **recordar, especialmente durante un conflicto, qué resultado querés
conseguir y ajustar tu manera de comunicarte a ese objetivo.**`,
  },
  [D10]: {
    title: "Canalizar tu energía",
    text: `Podrías estar poniendo mucha energía en aquello que te
preocupa, pero no siempre en el punto donde esa energía tiene mayor capacidad de
producir cambios.
Esto puede ocurrir por dispersión entre demasiados frentes o porque una parte importante
de tu esfuerzo se dirige a cuestiones sobre las que hoy tenés poca influencia.
El problema, entonces, no necesariamente es falta de esfuerzo. Puede ser una cuestión de
ubicación: **estás utilizando energía, pero no siempre donde genera mayor efecto.**
Para trabajar: **identificar dónde tu esfuerzo tiene capacidad real de modificar la
situación y concentrarlo allí.**`,
  },
  [C1]: {
    title: "Recuperar el equilibrio emocional", // I
    text: `Aunque habitualmente podés conservar cierto equilibrio,
algunas situaciones de presión o incertidumbre podrían afectar tu claridad más de lo
conveniente.
En esos momentos, problemas relativamente manejables pueden sentirse mayores porque
cambia el lugar desde el cual los estás mirando. **No necesariamente cambió la situación
en la misma proporción; pudo cambiar tu capacidad momentánea para evaluarla.**
El objetivo no es desconfiar de tus emociones, sino evitar tomar decisiones relevantes
desde el momento de mayor impacto.
Para trabajar: **darte un margen para recuperar perspectiva cuando una emoción intensa
empieza a modificar tu lectura de la situación.**`,
  },
  [C2]: {
    title: "Recuperar el equilibrio emocional", // II
    text: `Los cambios emocionales podrían estar influyendo con cierta
frecuencia sobre tu manera de interpretar problemas y decisiones. Una misma situación
puede parecer manejable en un momento y mucho más grave poco después.
Cuando esto se repite, resulta difícil sostener una dirección porque cada estado emocional
vuelve a abrir decisiones que parecían encaminadas.

Necesitás **recuperar un punto de observación más estable** desde el cual puedas reconocer
lo que sentís sin convertir cada cambio emocional en una nueva lectura completa de la
realidad.
Para trabajar: **evitar revisar decisiones importantes solamente porque cambió tu estado
emocional y buscar primero recuperar una mirada más estable.**`,
  },
  [C3]: {
    title: "Recuperar el equilibrio emocional", // III
    text: `En este momento, las emociones podrían estar condicionando
de manera importante tu capacidad para evaluar algunas situaciones con suficiente
distancia. Cuando la intensidad es muy alta, las alternativas pueden parecer menores y los
problemas más definitivos de lo que quizá sean.
En este nivel no siempre alcanza con proponerse “pensar con calma”. Puede ser necesario
apoyarte deliberadamente en otras personas o herramientas que te ayuden a recuperar
perspectiva.
**Buscar apoyo no significa perder autonomía. Puede ser precisamente una manera de
volver a recuperarla.**
Para trabajar: **no afrontar en soledad decisiones importantes mientras te resulte difícil
separar la intensidad emocional de los hechos concretos.**`
  },
  [C4]: {
    title: "Recuperar la capacidad de decidir", //I
    text: `Tendés a analizar bastante antes de tomar algunas decisiones
y que podrías prolongar ese proceso aun cuando ya contás con información suficiente
para avanzar.
La prudencia es un recurso; el problema comienza cuando la búsqueda de mayor
seguridad demora decisiones que ya podrían ponerse a prueba.
**No todas las dudas se resuelven antes de actuar.** Algunas solo pueden responderse
observando qué ocurre después de dar un primer paso.
Para trabajar: **establecer un punto a partir del cual el análisis termina y comienza la
decisión, aunque todavía permanezca cierta incertidumbre.**`
  },
  [C5]: {
    title: "Recuperar la capacidad de decidir", // II
    text: `La duda podría estar ocupando demasiado espacio en
decisiones relevantes. Cada alternativa genera nuevas preguntas y cada respuesta abre
otra posibilidad, haciendo que el proceso resulte difícil de cerrar.

En ese punto, **quizás ya no estés buscando una buena decisión sino una decisión sin
riesgo.** Y esa alternativa, en cuestiones verdaderamente importantes, muchas veces no
existe.
Mientras esperás certeza completa, la realidad también sigue avanzando y puede terminar
decidiendo por vos.
Para trabajar: **aceptar un nivel razonable de incertidumbre y decidir cuando la
información adicional ya no modifica sustancialmente las alternativas.**`
  },
  [C6]: {
    title: "Recuperar la capacidad de decidir", // III
    text: `Tomar algunas decisiones importantes podría estar
resultándote especialmente difícil, hasta el punto de mantener abiertas cuestiones que
necesitan algún tipo de definición.
Cuando muchas decisiones permanecen suspendidas, aparece una sensación de
inmovilidad: pensás, evaluás y volvés a pensar, pero la realidad no recibe ningún
movimiento al cual responder.
**El primer paso no necesita resolver todo. Necesita romper el circuito que mantiene la
situación detenida.** Si hoy hacerlo solo te resulta demasiado difícil, una mirada externa
puede ayudarte a recuperar perspectiva.
Para trabajar: **elegir una decisión concreta que pueda ponerse en movimiento y buscar
apoyo si la parálisis continúa impidiéndote avanzar.**`

  },
  [C7]: {
    title: "Rumbo con ajustes pendientes", // I
    text: `Existe una dirección general, aunque algunas prioridades
todavía pueden necesitar mayor definición. El principal riesgo no parece ser la ausencia
de rumbo, sino revisar demasiado pronto aquello que todavía no tuvo tiempo suficiente
para desarrollarse.
**Una idea necesita dos momentos diferentes: primero construcción; después evaluación.** Si
evaluás permanentemente mientras todavía estás construyendo, podés terminar
debilitando un camino antes de saber realmente qué podía ofrecer.
No toda duda exige cambiar de dirección.
Para trabajar: **darle al camino elegido un plazo razonable de desarrollo antes de volver
a evaluarlo, salvo que aparezcan hechos concretos que justifiquen corregirlo.**`
  },
  [C8]: {
    title: "Rumbo oscilante",
    text: `Tu dirección podría estar cambiando con demasiada facilidad
frente a nuevas dudas, dificultades o alternativas. Cuando cada cuestionamiento alcanza
para replantear el camino completo, ningún proyecto consigue suficiente continuidad
para demostrar sus posibilidades.
La pregunta clave es distinguir si apareció información que verdaderamente modifica la
situación o si simplemente apareció una nueva inquietud.
**Cambiar de rumbo puede ser inteligente. Cambiarlo cada vez que surge incertidumbre
impide construir.**
Para trabajar: **distinguir entre hechos que justifican una corrección y dudas que
necesitan ser toleradas mientras sostenés el camino elegido.**`
  },
  [C9]: {
    title: "Rumbo perdido",
    text: `Podrías estar atravesando una desorientación importante,
con dificultad para encontrar una dirección capaz de organizar tu energía y tus decisiones.
En esta situación, esperar hasta sentir absoluta claridad puede prolongar el vacío. Muchas
veces el rumbo empieza a reconstruirse al comprometerse con una experiencia
suficientemente valiosa, aunque todavía no existan todas las certezas.
**Un camino imperfecto puede darte información, aprendizaje y nuevos puntos de apoyo.**
Permanecer indefinidamente en la duda no produce esa respuesta.
Para trabajar: **elegir una dirección posible, convertirla en acciones concretas y
sostenerla lo suficiente para que la experiencia empiece a devolverte información.**`
  },
  [C10]: {
    title: "Mundo Percibido", // I
    text: `Podrías estar acercándote a algunas relaciones con más
cautela de la que la situación actual requiere. No necesariamente desconfiás abiertamente,
pero tendés a protegerte antes de comprobar si existe realmente una razón para hacerlo.
La prudencia es útil cuando responde a señales concretas. Cuando se anticipa
automáticamente a la experiencia, también puede cerrar oportunidades que nunca
llegaron a ser evaluadas.
**No necesitás confiar más. Necesitás distinguir mejor.**
Para trabajar: **observar a cada persona y situación por sus señales actuales, evitando
anticipar conclusiones solamente por experiencias anteriores.**`
  },
  [C11]: {
    title: "Mundo Percibido", // II
    text: `La desconfianza podría haberse convertido en una forma
bastante habitual de interpretar los vínculos. Desde ese lugar, delegar, apoyarte en otros o
compartir verdaderamente un proyecto puede resultar difícil incluso cuando no existen
señales concretas de peligro.
El problema es que intentar evitar toda decepción también reduce las oportunidades de
comprobar que algunas personas sí pueden ser confiables.
Protegerte sigue siendo necesario. Pero **una protección eficaz distingue entre personas y
contextos en lugar de aplicar la misma conclusión a todos.**
Para trabajar: **revisar qué desconfianzas se apoyan en hechos actuales y cuáles se han
transformado en una regla general sobre los demás.**`
  },
  [C12]: {
    title: "Mundo Percibido", // III
    text: `La desconfianza podría estar condicionando profundamente la
manera en que interpretás a otras personas. Cuando esto ocurre, el riesgo deja de
atribuirse a determinados vínculos y empieza a extenderse sobre casi todo el entorno.
Las experiencias difíciles pueden enseñar a protegernos, pero también pueden llevarnos a
construir un mapa en el que el pasado ocupa demasiado espacio dentro del presente.
**Recuperar confianza no significa suponer que todos son confiables. Significa volver a
desarrollar la capacidad de distinguir personas, situaciones y niveles reales de riesgo.**
Para trabajar: **cuestionar las generalizaciones sobre los demás y reconstruir
gradualmente criterios que permitan diferenciar riesgos reales de amenazas anticipadas.**`
  },
};
